// FieldIQ — Roster / network contact persistence + timeAgo

import { NETWORK_KEY } from "./sampleData";

const ROSTER_KEY = "fieldiq_roster";

export const loadRoster = () => {
  try {
    const raw = JSON.parse(localStorage.getItem(ROSTER_KEY) || "[]");
    return Array.isArray(raw) ? raw : [];
  } catch {
    return [];
  }
};

export const saveRoster = (contacts) => {
  try {
    localStorage.setItem(ROSTER_KEY, JSON.stringify(contacts));
  } catch {}
};

export const loadNetwork = () => {
  try {
    const raw = JSON.parse(localStorage.getItem(NETWORK_KEY) || "[]");
    return Array.isArray(raw) ? raw : [];
  } catch {
    return [];
  }
};
export const saveNetwork = (contacts) => {
  try {
    localStorage.setItem(NETWORK_KEY, JSON.stringify(contacts));
  } catch {}
};

const contactActivityKey = (id) => `fieldiq_act_${id}`;

export const loadContactActivity = (id) => {
  try {
    const raw = JSON.parse(
      localStorage.getItem(contactActivityKey(id)) || "[]",
    );
    return Array.isArray(raw) ? raw : [];
  } catch {
    return [];
  }
};

export const logContactActivity = (id, type, note = "") => {
  const acts = loadContactActivity(id);
  const entry = {
    id: `a-${Date.now()}`,
    type,
    note,
    ts: new Date().toISOString(),
  };
  const updated = [entry, ...acts];
  try {
    localStorage.setItem(contactActivityKey(id), JSON.stringify(updated));
  } catch {}
  return updated;
};

export const timeAgo = (iso) => {
  const diff = Date.now() - new Date(iso).getTime();
  const m = Math.floor(diff / 60000);
  if (m < 1) return "just now";
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  if (d < 7) return `${d}d ago`;
  return new Date(iso).toLocaleDateString();
};
